import { useEffect, useState } from "react"
import { Button, Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap"
import Template from "../../layout/Template"
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from "zod"
import { ProfissionaisService } from "../../services/api/Profissionais/ProfissionaisService"

import { useNavigate, useParams } from "react-router-dom"
import { limpaCpf, limpaTelefone } from "../../utils/Funcoes"
import { tiposServicosUtils } from '../../utils/tiposServicosUtils'
import { Commons } from "../../utils/Commons"
import { useHookFormMask } from 'use-mask-input';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Loading from "../../components/Loader/Loading"
import { usePermissoes } from "../../hooks/usePermissoes"
import PermissoesComponent from "../../components/PermissaoComponent"




const diasSemanaObj = z.object({
    id: z.coerce.string().nullable(),
    diasSemanasId: z.coerce.string().nullable(),
    inicio: z.coerce.string().nullable(),
    termino: z.coerce.string().nullable(),
    status: z.coerce.string().nullable(),
})
const profissionaisTpServicos = z.object({
    id: z.coerce.string().nullable(),
    nome: z.coerce.string().nullable(),
    value: z.coerce.string().nullable(),
})

const scheme = z.object({
    tiposPessoasId: z.string(),
    nome: z.string(),
    razaoSocial: z.string().nullable(),
    cpf: z.coerce.string().nullable(),
    sexo: z.string().nullable(),
    email: z.union([
        z.literal(''),
        z.literal(null),
        z.string().email('E-mail inválido')
    ]),
    telefone: z.coerce.string().nullable(),
    celular: z.string().nullable().nullable(),
    tiposServicos: z.array(z.coerce.string()),
    diasSemanas: z.array(diasSemanaObj),






}).refine((data) => { return !(data.tiposPessoasId.toString() === '1' && data.nome == '') }, {
    message: "O Nome é obrigatório",
    path: ["nome"], // path of error
}).refine((data) => { return !(data.tiposPessoasId.toString() === '2' && data.razaoSocial == '') }, {
    message: "A Razão Social é obrigatória",
    path: ["razaoSocial"], // path of error
})

const ProfissionalCadEdit = () => {


    const [disableSalvar, setDisableSalvar] = useState(false)
    const navigate = useNavigate()
    const { idProfissional } = useParams();
    const [profissional, setProfissional] = useState(null)

    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 4, acoesId: 1 },
        { secoesId: 4, acoesId: 2 },
    ])

    const { register, handleSubmit, watch, setValue, control, formState: { errors } } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(scheme),
        values: profissional
    })
    const registerWithMask = useHookFormMask(register);


    const [keyTab, setKeyTab] = useState('dadosPessoais')
    const [isPessoaJuridica, setIsPessoaJuridica] = useState(false)
    const watchShowJuridica = watch('tiposPessoasId')


    const diasSemanasPadrao = [
        { diasSemanasId: 1, dias_semanas: { nome: 'Domingo' }, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 2, dias_semanas: { nome: 'Segunda' }, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 3, dias_semanas: { nome: 'Terça' }, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 4, dias_semanas: { nome: 'Quarta' }, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 5, dias_semanas: { nome: 'Quinta' }, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 6, dias_semanas: { nome: 'Sexta' }, inicio: '08:00', termino: '17:00', status: 1 },
        { diasSemanasId: 7, dias_semanas: { nome: 'Sábado' }, inicio: '08:00', termino: '17:00', status: 1 }
    ]
    const tiposServicosPadrao = () => {
        let tpPadrao = []
        tiposServicosUtils().map((item) => {
            tpPadrao.push({
                tiposServicosId: item.id,
                nome: item.nome,
                value: true
            })

        });

        return [{ nome: 'esss', value: true }]
    }
    //console.log(useParams())

    const onSubmit = async (data) => {

        // console.log(data)
        setDisableSalvar(true)
        let DataForm = data
        DataForm.telefone = (DataForm.telefone != null) ? limpaTelefone(DataForm.telefone) : ''
        DataForm.celular = (DataForm.celular != null) ? limpaTelefone(DataForm.celular) : ''
        DataForm.cpf = (DataForm.cpf != null) ? limpaCpf(DataForm.cpf) : ''
        DataForm.cnpj = (DataForm.cnpj != null) ? limpaCpf(DataForm.cnpj) : ''
        DataForm.nome = (DataForm.tiposPessoasId == 1) ? DataForm.nome : DataForm.razaoSocial;

        console.log((DataForm))
        if (idProfissional != undefined) {
            const res = await ProfissionaisService.updateById(idProfissional, DataForm)

            if (res.success) {
                navigate('/admin/profissionais')
            } else {
                alert(res.msg)

                setDisableSalvar(false)

            }


        } else {
            const res = await ProfissionaisService.store(DataForm)

            if (res.success) {
                navigate('/admin/profissionais')
            } else {
                setDisableSalvar(false)

            }
        }

    }

    //console.log((idProfissional))

    useEffect(() => {

        if (idProfissional != undefined) {
            const fetchData = async () => {
                setIsloading(true);
                const data = await ProfissionaisService.getById(idProfissional)
                const cli = data.data
                let tpServForm = []
                if (cli?.profissional_tipos_servicos.length > 0) {
                    cli.profissional_tipos_servicos.map((item) => {
                        tpServForm.push(item.tiposServicosId.toString())
                    })

                    console.log(tpServForm)
                }

                setProfissional({
                    ...cli,
                    tiposPessoasId: (cli?.tipos_pessoas?.id) ? cli?.tipos_pessoas?.id.toString() : '',
                    uf: (cli?.ufs?.sigla) ? cli?.ufs?.sigla : '',
                    diasSemanas: (cli?.profissional_agenda.length > 0) ? cli?.profissional_agenda : diasSemanasPadrao,
                    tiposServicos: tpServForm,
                    razaoSocial: (cli?.tiposPessoasId == 2) ? cli?.nome : ''
                })
                setIsloading(false);
            }
            fetchData()
        } else {
            setIsloading(false);
            setValue('tiposPessoasId', '1')
        }

    }, [])

    const { fields: diasSemanasFields } = useFieldArray({ control, name: "diasSemanas" });

    useEffect(() => {
        if (watchShowJuridica == 2) {
            setIsPessoaJuridica(true)
        } else {
            setIsPessoaJuridica(false)
        }

        //console.log(watchShowJuridica)
    }, [watchShowJuridica])

    // console.log(profissional)
    //  console.log(diasSemanasFields)
    console.log(errors)
    return (
        <>
            <Template>
                <div className="box-fundo">
                    <h3><span className="text-primary">Profissionais </span> {(profissional?.nome != null) ? '- ' + profissional.nome : ''} {(profissional?.sobrenome != null) ? profissional.sobrenome : ''}</h3>
                    <h4 className="text-primary"></h4>
                    <hr></hr>


                    <div style={{ maxWidth: '800px' }}>

                        {(isLoading) ? <Loading /> : (

                            <>
                                {(
                                    (!listPermissoes?.cadastrar && !isLoadingPerm && idProfissional == null)
                                    || (!listPermissoes?.editar && !isLoadingPerm && idProfissional != null)
                                ) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                                    <>
                                        <Tabs
                                            activeKey={keyTab}
                                            onSelect={(k) => setKeyTab(k)}
                                            className="mb-3">
                                            <Tab eventKey="dadosPessoais" title="Dados Pessoais" >
                                                <Form>
                                                    <Row>
                                                        <Form.Group >
                                                            <Form.Label>Tipo de Pessoa:</Form.Label><br />
                                                            <Form.Check
                                                                inline
                                                                type="radio"
                                                                label="Pessoa Física"
                                                                value="1"

                                                                {...register('tiposPessoasId')}
                                                            ></Form.Check>
                                                            <Form.Check
                                                                inline
                                                                type="radio"
                                                                label="Pessoa Jurídica"
                                                                value="2"
                                                                {...register('tiposPessoasId')}></Form.Check>
                                                        </Form.Group>
                                                    </Row>

                                                    <div className="divPessoaJuridica" style={{ display: (isPessoaJuridica) ? '' : 'none' }}>
                                                        <Row >
                                                            <Form.Group as={Col} controlId="formRazaoSocial">
                                                                <Form.Label>Razão Social</Form.Label>
                                                                <Form.Control type="text" placeholder="Razão Social"
                                                                    {...register('razaoSocial')}
                                                                    isInvalid={!!(errors?.razaoSocial)}
                                                                ></Form.Control>
                                                            </Form.Group>
                                                            <Form.Control.Feedback type='invalid' >
                                                                {errors?.razaoSocial?.message}
                                                            </Form.Control.Feedback>
                                                        </Row>
                                                        <Row >

                                                            <Form.Group as={Col} controlId="formCnpj" xs={4} >
                                                                <Form.Label>CNPJ:</Form.Label>
                                                                <Form.Control type="text" placeholder="CNPJ"
                                                                    {...registerWithMask('cnpj', ['99.999.999/9999-99'])}
                                                                ></Form.Control>
                                                            </Form.Group>
                                                        </Row>


                                                    </div>

                                                    <div className="divPessoaFisica" style={{ display: (!isPessoaJuridica) ? '' : 'none' }}>

                                                        <Row className="lg-5" >
                                                            <Form.Group as={Col} controlId="formNome" xs={6}>
                                                                <Form.Label>Nome*</Form.Label>
                                                                <Form.Control type="text" placeholder="Nome"
                                                                    {...register('nome')}
                                                                    isInvalid={!!errors?.nome}
                                                                />
                                                                <Form.Control.Feedback type='invalid'>
                                                                    {errors?.nome?.message}
                                                                </Form.Control.Feedback>
                                                            </Form.Group>

                                                        </Row>
                                                        <Row >
                                                            <Form.Group as={Col} md={4} controlId="formCpf">
                                                                <Form.Label>CPF:</Form.Label>
                                                                <Form.Control type="text" placeholder="CPF"
                                                                    {...registerWithMask('cpf', ['999.999.99.-99'])} />
                                                            </Form.Group>
                                                            <Form.Group as={Col} md={4} controlId="formSexo">
                                                                <Form.Label>Sexo:</Form.Label>
                                                                <Form.Select placeholder="Sexo"
                                                                    {...register('sexo')}>
                                                                    <option value=''>Selecione...</option>
                                                                    <option value='M'>Masculino</option>
                                                                    <option value='F'>Feminino</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Row>
                                                    </div>
                                                    <Row>
                                                        <Form.Group as={Col} controlId="formEmail" xs={12} md={4}>
                                                            <Form.Label>E-mail</Form.Label>
                                                            <Form.Control type="text" placeholder="E-mail" isInvalid={!!errors?.email}
                                                                {...register('email')} />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors?.email?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formTelefone" className="align-self-start">
                                                            <Form.Label>Telefone</Form.Label>
                                                            <Form.Control type="text" placeholder="Telefone"

                                                                {...registerWithMask('telefone', ['(99) 9999-9999'])}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formCelular">
                                                            <Form.Label>Celular</Form.Label>
                                                            <Form.Control type="text" placeholder="Celular"
                                                                {...registerWithMask('celular', ['(99) 99999-9999'])}
                                                            ></Form.Control>
                                                        </Form.Group>
                                                    </Row>
                                                    <hr></hr>
                                                    <h4>Tipos de serviços:</h4>
                                                    <Row>
                                                        <Form.Group as={Col}>

                                                            {
                                                                tiposServicosUtils()?.map((campo, index) => (
                                                                    <>
                                                                        <Form.Check
                                                                            inline
                                                                            type="checkbox"
                                                                            label={campo?.nome}
                                                                            value={campo?.id}
                                                                            {...register('tiposServicos')}
                                                                        ></Form.Check>


                                                                    </>
                                                                ))
                                                            }

                                                        </Form.Group>

                                                    </Row>




                                                </Form>
                                            </Tab>

                                            <Tab eventKey="agenda" title="Agenda" style={{ padding: '5px' }}>
                                                <h5 className="">Configuração de agenda</h5>
                                                <br></br>

                                                <Row>
                                                    <Form.Label>Quantidade de agendamentos por horário:</Form.Label>
                                                </Row>

                                                {(diasSemanasFields != null) ? (
                                                    <>
                                                        <Row className="d-none d-md-flex" style={{ paddingTop: '5px', paddingBottom: '5px', borderBottom: '1px solid #fffbfbff', background: '#efefef' }}>
                                                            <Form.Group as={Col} controlId="" xs={12} md={2}>
                                                                <Form.Label></Form.Label>
                                                            </Form.Group>
                                                            <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                                <Form.Label>Início</Form.Label>
                                                            </Form.Group>
                                                            <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                                <Form.Label>Término</Form.Label>
                                                            </Form.Group>
                                                            <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                                <Form.Label>Habilitado?</Form.Label>
                                                            </Form.Group>
                                                            <Form.Group as={Col} controlId="formNomeContato" xs={12} md={3}>
                                                            </Form.Group>
                                                        </Row>
                                                    </>
                                                ) : ''}
                                                {diasSemanasFields?.map((campo, index) => (

                                                    <Row style={{ paddingTop: '5px', paddingBottom: '5px', borderBottom: '1px solid #fffbfbff' }}>
                                                        <Form.Group as={Col} controlId="" xs={12} md={2} className="text-center">
                                                            <Form.Label>{campo?.dias_semanas?.nome}</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                            <Form.Label className='d-md-none d-flex'>Início</Form.Label>
                                                            <Controller
                                                                render={({ field }) => <input type="time" {...field} className="form-control" />}
                                                                name={`diasSemanas.${index}.inicio`}
                                                                control={control}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                            <Form.Label className='d-md-none d-flex'>Término</Form.Label>
                                                            <Controller
                                                                render={({ field }) => <input type="time" {...field} className="form-control" />}
                                                                name={`diasSemanas.${index}.termino`}
                                                                control={control}
                                                            />
                                                        </Form.Group >
                                                        <Form.Group as={Col} controlId="" xs={12} md={3}>
                                                            <Form.Label className='d-md-none d-flex'>Habilitado?</Form.Label>
                                                            <Controller
                                                                render={({ field }) => <select  {...field} className="form-select">
                                                                    <option value="1">Sim</option>
                                                                    <option value="0">Não</option>
                                                                </select>
                                                                }
                                                                name={`diasSemanas.${index}.status`}
                                                                control={control}
                                                            />

                                                        </Form.Group>
                                                    </Row>
                                                ))}






                                            </Tab>
                                        </Tabs>
                                        <br></br>
                                        <div className="text-center ">
                                            <Button variant="danger" className="mr-15" href="/admin/profissionais" size="sm">Cancelar</Button>
                                            <Button variant="primary" disabled={disableSalvar} size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                                {(disableSalvar) ? <>
                                                    <FontAwesomeIcon icon={["fas", "spinner"]} spin /> Salvando...
                                                </> : 'Salvar'}</Button>

                                        </div>
                                    </>)}
                            </>)}
                    </div>
                </div>
            </Template >

        </>
    )
}
export default ProfissionalCadEdit